import { useWeb3React } from '@web3-react/core';
import { useCallback } from 'react';

import { networkConfigs } from '../../constants';
import { ProtocolName } from '../../constants/protocolNames';
import { useAppDispatch } from '../../store';
import { updateAllQuotes } from '../../store/state/swap/swapSlice';
import { QuoteUpdater } from './types';
import { useUpdateOneInchQuote } from './useUpdateOneInchQuote';
import { useUpdateParams } from './useUpdateParams';

export const useUpdate = () => {
  const { chainId } = useWeb3React();
  const dispatch = useAppDispatch();

  const params = useUpdateParams();

  const oneInchUpdater = useUpdateOneInchQuote();

  return useCallback(() => {
    if (!params || !chainId) return;

    const update: { [protocolName: string]: QuoteUpdater } = {
      [ProtocolName.ONE_INCH]: { name: ProtocolName.ONE_INCH, update: () => oneInchUpdater(params) },
    };

    console.log('supportedProtocols', networkConfigs[chainId].supportedProtocols);
    networkConfigs[chainId].supportedProtocols.forEach((protocol) => {
      const protocolName = update[protocol].name;
      const quoteId = new Date().getTime();
      console.log('protocolName', protocolName);
      dispatch(
        updateAllQuotes({
          quote: { [protocolName]: null },
          loading: { loadingStatus: 'pending', quoteId },
          error: null,
        })
      );

      update[protocol]
        .update()
        .then((quote) => {
          if (quote === null) {
            dispatch(
              updateAllQuotes({
                quote: { [protocolName]: null },
                loading: { loadingStatus: 'failed', quoteId },
                error: `Couldn't get ${protocolName} quota`,
              })
            );
            return;
          }
          dispatch(
            updateAllQuotes({
              quote: { [protocolName]: quote },
              loading: { loadingStatus: 'succeeded', quoteId },
              error: null,
            })
          );
        })
        .catch((error) => {
          console.error('ERROR', error);
          dispatch(
            updateAllQuotes({
              quote: { [protocolName]: null },
              loading: { loadingStatus: 'failed', quoteId },
              error: error.message,
            })
          );
        });
    });
  }, [params, oneInchUpdater]);
};
